import { makeStyles } from '@material-ui/core/styles'

const headerStyles = makeStyles((theme) => ({
  programHeaderBar: {
    // border: '2px solid black',
    // margin: '2% 2% 1.3%',
    padding: '20px 41px 0px 41px',
    height: '4em',
    width: 'auto',
    background: '#FFFFFF',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  programDetailsDynamicInstallerHomePage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // border: '2px solid black',
    width: '35em',
    marginRight: '1em',
    '@media (max-height: 800px), (max-width: 1400px)': {
      width: '32em',
      marginRight: '0',
      // border: '2px solid green',
    },
  },
  programDetailsDynamicEditRejectedApplication: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // border: '2px solid black',
    width: '100em',

    marginRight: '1em',
  },
  programDetailsDynamicRejectedApplication: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // border: '2px solid black',
    width: '60em',

    marginRight: '1em',
  },
  programDetailsDynamicSubmitNewApplication: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // border: '2px solid black',
    width: '35em',

    marginRight: '1em',
  },
  programDetailsStatic: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // border: '2px solid black',
    width: '100%',
  },
  programTitle: {
    // border: '2px solid green',
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '2em',
    marginRight: '4%',
    '@media (max-height: 800px), (max-width: 1400px)': {
      fontSize: '1.8em',
      // border: '2px solid green',
    },

    // width: '800px',
  },
  staticMargin: {
    marginLeft: '3%',
  },
  popWrapper: {
    padding: '30px',
    color: '#565657',
    fontSize: '16px',
    textAlign: 'center',
  },
  ackButton: {
    marginTop: '20px',
    width: 'auto',
    height: 'auto',
  },
  popText: {
    fontSize: '18px',
  },
}))

export { headerStyles }
